/* eslint-disable react/require-default-props */
import { Box, Checkbox, Text } from '@chakra-ui/core';
import React from 'react';
import { FaSort, FaSortDown, FaSortUp } from 'react-icons/fa';
import { HeaderGroup, SortingRule } from 'react-table';
import type { Position } from '../types';
import colors from '../../../../../styles/colors';
import { SortPosition } from './SortPosition';
import { useStoreActions, useStoreState } from '../../../../../models/hooks';

interface TableHeadProps {
  children: React.ReactNode;
  column: HeaderGroup<Position>;
  sortBy?: SortingRule<Position>;
}

function TableHead({ children, column }: TableHeadProps) {
  let sortIcon = null;
  if (column.isSorted) {
    sortIcon = column.isSortedDesc ? /* istanbul ignore next */ <FaSortDown color="blue" /> : <FaSortUp color="blue" />;
  } else if (column.canSort) {
    sortIcon = <FaSort color="#ccc" />;
  }
  return (
    <Box
      {...column.getHeaderProps(column.getSortByToggleProps())}
      px={2}
      py={1}
      display="flex"
      alignItems="center"
      textColor={column.isSorted ? 'blue' : 'default'}
    >
      {children}
      <Box ml={1}>{sortIcon}</Box>
    </Box>
  );
}

interface PositionTableHeaderProps {
  headerGroups: HeaderGroup<Position>[];
  sortBy: SortingRule<Position>[];
}

function PostionTableHeaderComponent({ headerGroups, sortBy }: PositionTableHeaderProps) {
  const { areAllPositionsSelected, isSomePositionsSelected } = useStoreState((state) => state.moniterByRecruiters);
  const { setSelectedPositions } = useStoreActions((state) => {
    return state.moniterByRecruiters;
  });
  const tableColor = colors.table;

  return (
    <Box
      sx={{
        borderBottom: '1px solid #e5e5e5',
        backgroundColor: tableColor.headerBg,
      }}
      position="sticky"
      top={0}
      zIndex={1}
    >
      {headerGroups.map((headerGroup) => (
        <Box {...headerGroup.getHeaderGroupProps()} key={headerGroup.id} display="flex" flexDirection="row">
          {headerGroup.headers.map((column) => {
            switch (column.id) {
              case 'checkbox':
                return (
                  <TableHead column={column} key={column.id}>
                    <Checkbox
                      isChecked={areAllPositionsSelected}
                      isIndeterminate={isSomePositionsSelected}
                      onChange={(e) => {
                        setSelectedPositions({ positions: [], isAllSelected: e.target.checked });
                      }}
                    />
                  </TableHead>
                );
              case 'stats':
                return (
                  <TableHead column={column} key={column.id}>
                    <SortPosition />
                  </TableHead>
                );
              default:
                return (
                  <TableHead column={column} key={column.id} sortBy={sortBy?.find((s) => s.id === column.id)}>
                    <Text
                      textAlign="left"
                      fontSize="sm"
                      color={column.isSorted ? tableColor.sortActive : tableColor.headerTextColor}
                      fontWeight={column.isSorted ? 'bold' : 'normal'}
                    >
                      {`${column.render('Header')?.toString()}`}
                    </Text>
                  </TableHead>
                );
            }
          })}
        </Box>
      ))}
    </Box>
  );
}

export const PostionTableHeader = React.memo(PostionTableHeaderComponent);
